// extracted by mini-css-extract-plugin
export default {"container":"PreGame_container__oZ0O2"};